/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable } from '@angular/core';
import { RichResultsService } from '../rich-results.service';

@Injectable({
  providedIn: 'root',
})
export class RichResultsBrowserService implements RichResultsService {
  setJsonLd(): void {}
  setTrustpilotRatesJsonLd(): void {}
}
